import client, { buildSignedRequestHeaders } from "../axios";
import { DefaultService } from "./DefaultService";
import { HttpStatusCode } from "../HttpStatusCode";

export default class AppointmentService extends DefaultService {
  public static readonly entityUrl = "appointments";
  private static readonly signaturePath = "/api/v1/appointments";

  static getHoursAvailableInterval(
    clinic_id: number | string,
    startDate: string,
    endDate: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      return client
        .get(`${AppointmentService.entityUrl}/${clinic_id}/${startDate}/${endDate}`)
        .then((response) => {
          if (response.status === HttpStatusCode.OK) resolve(response);
          else reject(new Error(response.statusText));
        })
        .catch((error) => reject(error instanceof Error ? error : new Error(error)));
    });
  }

  static getHoursAvailable(clinic_id: number | string, date: string): Promise<any> {
    return new Promise((resolve, reject) => {
      return client
        .get(`${AppointmentService.entityUrl}/${clinic_id}/${date}`)
        .then((response) => {
          if (response.status === HttpStatusCode.OK) resolve(response);
          else reject(new Error(response.statusText));
        })
        .catch((error) => reject(error instanceof Error ? error : new Error(error)));
    });
  }

  static getClinicGroupAvailableHours(date: string, data: { [index: string]: any }): Promise<any> {
    const arrayIds = {
      clinic_ids: data
    };
    return new Promise((resolve, reject) => {
      return client
        .post(`${AppointmentService.entityUrl}/${date}`, arrayIds)
        .then((response) => {
          if (response.status === HttpStatusCode.OK) resolve(response);
          else reject(new Error(response.statusText));
        })
        .catch((error) => reject(error instanceof Error ? error : new Error(error)));
    });
  }

  static getAppointment(crx_id: number | string, env: string): Promise<any> {
    return new Promise((resolve, reject) => {
      return client
        .get(`${AppointmentService.entityUrl}/get-by-crxid?crx_id=${crx_id}&env=${env}`)
        .then((response) => {
          if (response.status === HttpStatusCode.OK) resolve(response);
          else reject(new Error(response.statusText));
        })
        .catch((error) => reject(error instanceof Error ? error : new Error(error)));
    });
  }

  static setAppointment(data: { [index: string]: any }): Promise<any> {
    const { authorization, body, timestamp } = buildSignedRequestHeaders({
      method: "POST",
      path: AppointmentService.signaturePath,
      data,
    });

    return new Promise((resolve, reject) => {
      return client
        .post(AppointmentService.entityUrl, body, {
          headers: {
            Authorization: authorization,
            "Content-Type": "application/json",
            "X-Timestamp": timestamp,
          },
        })
        .then((response) => {
          if (response.status === HttpStatusCode.CREATED || response.status === HttpStatusCode.OK) {
            if (response.data && response.data.success === false) {
              reject(new Error(response.data.join("\n")));
            } else {
              resolve(response);
            }
          } else {
            reject(new Error(response.data.join("\n")));
          }
        })
        .catch((error) =>
          reject(error instanceof Error ? error : new Error(String(error)))
        );
    });
  }
}
